export { default as PlacesSearchAutocomplete } from './PlacesSearchAutocomplete';
export type {
  PlacesSearchAutocompleteOption,
  PlacesSearchAutocompleteProps,
} from './PlacesSearchAutocomplete';
